import { EventVolunteerRegistrationStatus } from '@/types'

export const registrationStatuses: EventVolunteerRegistrationStatus[] = ['None', 'RegisteredToEventSystem', 'AcceptedRegistration', 'InformedToOrganizers', 'RegistrationCancelled']
